// removed by extract-text-webpack-plugin
module.exports = {"empty-cart":"_3RRDGHFYJJeq0NGeoOVq-z","checkoutBanner":"_1FicAyf4nOF3YhbXx4pF-S","checkoutBanner__text":"_3hGdJFRtyKKYzWHNushOv8","checkoutBanner__inner":"_1zc1BypIYJgEFEYh6gzENB","completed-order":"_1F5LFQUg8gzb5sORscys5T","specialnotice":"_1UdJWMVtr8bJVLLdBLT3tL"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/CheckoutBanner/style.scss
// module id = 440
// module chunks = 0